import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import config from "../../../config/api";
import axiosInstance from "../../../config/axiosConfig";

export const updateOngoingHardwareParts = createAsyncThunk(
  "projectOngoing/update",
  async ({ projectId, id, updatedData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.put(
        `${config.backendUrl}/hardware-description/update/${projectId}/${id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update project hardware description"
      );
    }
  }
);


export const updateOngoingDescription = createAsyncThunk(
  "projectOngoing/updateDescription",
  async ({ projectId, id, updatedData }, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const response = await axiosInstance.put(
        `${config.backendUrl}/descriptiontask/update/${projectId}/${id}`,
        updatedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to update project hardware description"
      );
    }
  }
);

const ProjectOngoingUpdateSlice = createSlice({
  name: "projectOngoingUpdate",
  initialState: {
    loading: false,
    success: false,
    error: null,
    updatedProject: null,
  },
  reducers: {
    resetProjectOngoingUpdateState: (state) => {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.updatedProject = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateOngoingHardwareParts.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateOngoingHardwareParts.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedProject = action.payload;
      })
      .addCase(updateOngoingHardwareParts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
           .addCase(updateOngoingDescription.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
      })
      .addCase(updateOngoingDescription.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.updatedProject = action.payload;
      })
      .addCase(updateOngoingDescription.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetProjectOngoingUpdateState } = ProjectOngoingUpdateSlice.actions;
export default ProjectOngoingUpdateSlice.reducer;
